/**
 * Local-calendar-date helpers for the F2 calendar/dosing UI.
 *
 * The shared recurrence engine works on `YYYY-MM-DD` strings interpreted
 * as calendar days. These helpers convert the browser's *local* clock to
 * that string form so "today" matches the operator's wall-clock day (not
 * UTC). Date math inside the engine stays UTC-based and DST-safe; this
 * module only ever produces / compares the date label.
 */

/** Today's local calendar date as `YYYY-MM-DD`. */
export function localTodayIso(now: Date = new Date()): string {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/** Build a `YYYY-MM-DD` label from explicit local Y/M/D parts. */
export function isoFromParts(year: number, month1: number, day: number): string {
  const m = String(month1).padStart(2, '0');
  const d = String(day).padStart(2, '0');
  return `${year}-${m}-${d}`;
}

/** Compare two `YYYY-MM-DD` strings lexically (valid since fixed-width). */
export function compareIso(a: string, b: string): number {
  return a < b ? -1 : a > b ? 1 : 0;
}
